<template>
  <div :style="bigScreen ? 'margin: 0% 10%;' : 'margin: 0% 3%;'">
    <br /><br />
    <h1 :style="'font-size:' + size + 'em;'" class="bold">
      Github Project
    </h1>
    <br />
    <b-button
      target="_blank"
      variant="info"
      href="https://github.com/dindonero/CCU-2021-Queued.git"
      >Click here</b-button
    >
    <br /><br /><br />
    <h1 :style="'font-size:' + size + 'em;'" class="bold">
      Low Functional Prototypes
    </h1>
    <v-divider style="background-color: #26BFC9; width: 50%;"></v-divider>
    <h2 :style="'font-size:' + size3 + 'em;'" class="bold">
      Cliente Prototype
    </h2>
    <br />
    <iframe
      style="border: 1px solid rgba(0, 0, 0, 0.1);"
      width="100%"
      height="450"
      src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FO2YRYCMB9uDpjJ6AcKTfNs%2FPrototype-Client%3Fnode-id%3D1%253A1035%26scaling%3Dscale-down"
      allowfullscreen
    ></iframe>
    <br /><br />
    <h2 :style="'font-size:' + size3 + 'em;'" class="bold">
      Company Prototype
    </h2>
    <br />
    <iframe
      style="border: 1px solid rgba(0, 0, 0, 0.1);"
      width="100%"
      height="450"
      src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2F6HVZMYFw02xYWTpq8yx5EU%2FPrototype-Company%3Fnode-id%3D1%253A560%26scaling%3Dscale-down"
      allowfullscreen
    ></iframe>
    <br /><br /><br /><br />
    <h1 :style="'font-size:' + size + 'em;'" class="bold">
      High Functional Prototypes
    </h1>
    <v-divider style="background-color: #26BFC9; width: 50%;"></v-divider>
    <h2 :style="'font-size:' + size3 + 'em;'" class="bold">
      Cliente Prototype
    </h2>
    <br />
    <iframe
      style="border: 1px solid rgba(0, 0, 0, 0.1);"
      width="100%"
      height="450"
      src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FpyqT4ZPnleA8nRWPAavX0r%2FPrototype-Client-High%3Fnode-id%3D1%253A1035%26scaling%3Dscale-down"
      allowfullscreen
    ></iframe>
    <br /><br />
    <h2 :style="'font-size:' + size3 + 'em;'" class="bold">
      Company and Staff Prototypes
    </h2>
    <br />
    <iframe
      style="border: 1px solid rgba(0, 0, 0, 0.1);"
      width="100%"
      height="450"
      src="https://www.figma.com/embed?embed_host=share&url=https%3A%2F%2Fwww.figma.com%2Fproto%2FJGRpr3HXjzoDL1g2x6rrIt%2FPrototype-Company-High%3Fnode-id%3D1%253A560%26scaling%3Dscale-down"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "landingpage1",
  data() {
    return {
      bigScreen: true,
      size: 5,
      size2: 2,
      size3: 3
    };
  },
  methods: {
    update() {
      window.innerWidth > 1000
        ? (this.bigScreen = true)
        : (this.bigScreen = false);
      var height = (window.innerWidth * 9) / 12;
      var ems = height / 20;
      this.size = ems / 20;
      this.size2 = 0.5 * this.size;
      this.size3 = 0.6 * this.size;
      if (this.size < 1.3) {
        this.size = 1.3;
        this.size2 = 1.2;
        this.size3 = 1.3;
      }
    }
  },
  mounted() {
    this.update();
    this.$options.interval = setInterval(this.update, 500);
  }
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #ffffff;
}

.bold {
  font-weight: bold;
}
</style>
